import { render, staticRenderFns } from "./RcDivider.vue?vue&type=template&id=5c259624&"
import script from "./RcDivider.vue?vue&type=script&lang=js&"
export * from "./RcDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports